import { CRUD, DataType } from '@/interfaces'
import { checkPermission } from '@/store/permissions'
import { RouteRecordRaw } from 'vue-router'

const accountRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'settings-root',
    redirect: '/account/profile',
    meta: {
      hideProcessingPanel: true
    }
  },
  {
    path: 'profile',
    name: 'profile',
    component: () => import('@/components/settings/SettingsPersonal.vue'),
    meta: {
      title: 'profile',
      navbar: 'account',
      hideProcessingPanel: true
    },
    beforeEnter: (to, from, next) => checkPermission('settings_personal_info', next)
  },
  {
    path: 'new-password',
    name: 'accountsNewPassword',
    component: () => import('@/views/password/NewPassword.vue'),
    meta: {
      title: 'settings',
      hideProcessingPanel: true
    }
  },
  {
    path: 'settings',
    name: 'settings',
    component: () => import('@/components/settings/SettingsOrganizationDetails.vue'),
    meta: {
      title: 'settings',
      navbar: 'account',
      hideProcessingPanel: true
    },
    beforeEnter: (to, from, next) => checkPermission('settings_personal_info', next)
  },
  {
    path: 'users',
    name: 'users',
    props: true,
    component: () => import('@/components/settings/users/SettingsUsers.vue'),
    meta: {
      title: 'users',
      navbar: 'account',
      hideProcessingPanel: true
    },
    children: [
      {
        path: 'add',
        name: 'pb-add-user',
        component: () => import('@/components/settings/users/SettingsAddUser.vue'),
        meta: {
          title: 'users',
          hideProcessingPanel: true
        },
        children: [
          {
            path: 'closeunsaved',
            name: 'add-closeUnsavedUser',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'users'
            },
            props: { type: DataType.Account, action: CRUD.ConfirmClose }
          }
        ]
      },
      {
        path: 'edit/:id',
        name: 'pb-edit-user',
        component: () => import('@/components/settings/users/SettingsEditUser.vue'),
        props: true,
        meta: {
          title: 'users',
          hideProcessingPanel: true
        },
        children: [
          {
            path: 'closeunsaved',
            name: 'edit-closeUnsavedUser',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'users'
            },
            props: { type: DataType.Account, action: CRUD.ConfirmClose }
          },
          {
            path: 'deactivate',
            name: 'edit-deactivateuser',
            component: () => import('@/components/modals/custom-confirmation/CustomConfirmation.vue'),
            meta: {
              title: 'users'
            },
            props: { type: DataType.Account, action: CRUD.Deactivate }
          }
        ]
      }
    ],
    beforeEnter: (to, from, next) => checkPermission('settings_users', next)
  },
  {
    path: 'billing',
    name: 'billing',
    component: () => import('@/components/settings/SettingsBilling.vue'),
    meta: {
      title: 'billing',
      hideProcessingPanel: true
    },
    beforeEnter: (to, from, next) => checkPermission('settings_billing', next)
  },
  {
    path: 'system-info',
    name: 'system-info',
    component: () => import('@/components/settings/SystemInfo.vue'),
    meta: {
      title: 'system-info',
      hideProcessingPanel: true
    }
  },
  {
    path: 'api-keys',
    name: 'api-keys',
    component: () => import('@/components/settings/api-keys/SettingsApiKeys.vue'),
    meta: {
      title: 'api-keys',
      navbar: 'account',
      hideProcessingPanel: true
    },
    beforeEnter: (to, from, next) => checkPermission('api_keys', next)
  }
]

export default accountRoutes
